import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import SitePage, { SectionHeader, Meander } from './SiteChrome';
import { WORK, workBySlug } from './workData';
import { WorkCard } from './SiteHome';
import StudioIndex from './StudioIndex';

// Work (spec §4): proof. A grid of tiles; each opens a case layout — Ken Burns
// hero, three-paragraph narrative (the situation, what we built, what changed),
// an offset supporting-image pair, next-project teaser. No filters, no
// categories.

export default function Work() {
  return (
    <SitePage>
      <section className="ac-section" id="cases">
        <div className="ac-lightwash" aria-hidden="true" />
        <div className="ac-wrap" style={{ position: 'relative' }}>
          <SectionHeader kicker="Work" title="The proof is the work." />
          <div className="ac-work-grid">
            {WORK.map((w, i) => (
              <WorkCard key={w.slug} work={w} index={`0${i + 1}`} delay={i * 0.12} />
            ))}
          </div>
        </div>
      </section>
      <Meander />
      {/* Studio index — three 4×4 mosaics with the lightbox */}
      <StudioIndex />
    </SitePage>
  );
}

export function CaseStudy() {
  const { slug } = useParams();
  const work = workBySlug(slug);
  if (!work) return <Navigate to="/work" replace />;
  const next = WORK[(WORK.indexOf(work) + 1) % WORK.length];

  return (
    <SitePage>
      <article>
        <section className="ac-section" style={{ paddingBottom: 0 }}>
          <div className="ac-wrap">
            <SectionHeader kicker={work.scope} title={work.title} />
          </div>
          <div className="ac-wrap ac-reveal-wipe">
            <div className="ac-case-hero">
              <img src={work.image} alt={work.imageAlt || work.title} />
            </div>
          </div>
        </section>
        <section className="ac-section">
          <div className="ac-wrap">
            <div className="ac-case-body">
              {work.narrative.map((p, i) => (
                <p key={i} className={`ac-reveal ${i === 0 ? 'ac-dropcap' : ''}`} style={{ '--d': `${i * 0.1}s` }}>{p}</p>
              ))}
              {work.pullquote && <blockquote className="ac-pullquote ac-reveal">{work.pullquote}</blockquote>}
            </div>
            {work.images?.length >= 2 && (
              <div className="ac-case-pair">
                <figure className="ac-reveal-wipe">
                  <img src={work.images[0].src} alt={work.images[0].alt} loading="lazy" />
                </figure>
                <figure className="ac-reveal-wipe" style={{ '--d': '0.15s' }}>
                  <img src={work.images[1].src} alt={work.images[1].alt} loading="lazy" />
                </figure>
              </div>
            )}
            {work.wide && (
              <figure className="ac-case-wide ac-reveal-wipe">
                <img src={work.wide.src} alt={work.wide.alt} loading="lazy" />
              </figure>
            )}
            {work.deliverables && (
              <div className="ac-deliv ac-reveal">
                <span className="ac-kicker">Delivered</span>
                <ul>
                  {work.deliverables.map((d) => <li key={d}>{d}</li>)}
                </ul>
              </div>
            )}
          </div>
          <Meander />
          <Link className="ac-next" to={`/work/${next.slug}`}>
            <div className="ac-next-bg" style={{ backgroundImage: `url(${next.image})` }} aria-hidden="true" />
            <div className="ac-wrap ac-next-inner">
              <span className="ac-kicker">Next project</span>
              <h2>{next.title} →</h2>
            </div>
          </Link>
        </section>
      </article>
    </SitePage>
  );
}
